import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useMemo,
} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaRegComment, FaCaretDown } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useHistory } from "react-router-dom";
import { LoadingContext } from "../../contexts/loading.context";
import ReactPaginate from "react-paginate";
import "./comment.css";
import { UserContext } from "../../contexts/user.context"
import HeadContainer from "../../components/HeadContainer/HeadContainer";
import HeaderOptions from '../../components/HeaderOptions/HeaderOptions';
import Search from "../../components/HeadContainer/Search/Search";

const Comments = props => {

  const [user] = useContext(UserContext)
  const [dataPublish, setDataPublish] = useState([]);
  const [dataDraft, setDataDraft] = useState([]);
  const [dataTrash, setDataTrash] = useState([]);
  const [dataAproved, setDataAproved] = useState([]);
  const [data, setData] = useState([{ id: 1, name: 'Juana Rostran Marenco', mail: 'jnrostran@gmail.com', phone_number: '5231 5664', image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAOBSURBVDiNdZNrTFt1GMaf/zltz+kp7VgrtUw2WGF0QJRNqM4tcbDFuRAnkZhl8xIxJBKcEEzmF6OmSybxFi8Yl4Aki/hhM0STbWQlLoNFWTYZIFl0m6PrjUuB0kLbc9qe9vT8/aCQkOjv0/vpSZ68zw8A0D1dxuFfvmymzu52ygEAFX4szAmXTlCMaPA/kM9nivRswtirylx7+sPXdh2wV7cZzIJdiqf8tzzegTcGC3yUUJmTGm+7XJRxuYi6IcD1Z5WuADAzn7Y985Kjvs/E6XUgAIwayIxKB2+Offti79FWAPi6me4kKsJv9ZPIesDaMfHOiNthsT29sBD1lVqtVeBZgAAKUfHd5PUW7+Ijm0vNrLblXP1HZ30l/Ovb/WkA0HzxCi2kHGQxM+QNSXF7z+iVYx8UHZzy7RtiVYTp/Fx55MGS6eUGS2ldwhCc7Z4uO5OQ2Q4ApwFAIwiIyRxy+796r7Phif3PXh6fvFeTb1gt335jU/XmPM273zN5D206ZMvwoXQ2l9J37PDEXRRd6xUoKAFOkTNH97icum3vn4/Kd37749fkc/UXSxxWQecwvGCoZPay6nAYIUjpIfiPt1zbOqzwOac2feQqobhgzPFoerNh4ee3rbuDS8s0Y3XQ8E7eUkwDEqBQ5AIiAhoxMkrk+/1hz/Hh308GcsLFVobR/MQQNCZAkOy5XMi7w/7PKoqQdUSF4uxfMdyNLy2Nrqzc6aII97GVlpjtyFOVhXXfAGAYwl4gYkOYBYBTyrm7UM7Hxh/VIqJk7TMrvNgTlPhpXZUlll9VkGJ4w3zKA5upGDqWL4+q3Gqb9IMPsi39z8IoQa/XbrTZvSO/PD/ZtLus+qBJXURI9KKCfYB8RgBjroCUiWNu1QMTZy6GQkTgRpoBAEJAUxndiZWJGoZQyoMC+XkF2GZ2YFbcgjExBWoKg4AipYiqypCrx5wn9dhSo2fW3tFZca+rtXZCmZq9FvTNzmEh7gfLahB9+D5KrbXQGhQsJ0OQsuLA6GTn4L6SwzzmJ5LrSwQAGOsdoEq0aVdnv7PowGFOI2BZDiCbySEqLUZS2rm+xz8+fVOnz7o7dnhkANhoWSIdPLSn+bG9W5tevT4zUKvXCHXJTJxIyur4lG/E/cnYLSUhc+1yUrgCQN7gwhpnmykfkKC6Bkgmy1+qYwh9UmGom5Mab/+Xzn8Dd8iKHl3kdcMAAAAASUVORK5CYII=', usr_comment: 'Lorem Ipsum dolor sit amet consectetur elit adipiscing. ur elit adipiscing', product: '#110899 Lorem Ipsum Dolor sit amet consectetur elit adi', badge_count: '5', date: '22/22/22', meta: [], isHighLight: true, }, { id: 1, name: 'Juana Rostran Marenco', mail: 'jnrostran@gmail.com', phone_number: '5231 5664', image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAOBSURBVDiNdZNrTFt1GMaf/zltz+kp7VgrtUw2WGF0QJRNqM4tcbDFuRAnkZhl8xIxJBKcEEzmF6OmSybxFi8Yl4Aki/hhM0STbWQlLoNFWTYZIFl0m6PrjUuB0kLbc9qe9vT8/aCQkOjv0/vpSZ68zw8A0D1dxuFfvmymzu52ygEAFX4szAmXTlCMaPA/kM9nivRswtirylx7+sPXdh2wV7cZzIJdiqf8tzzegTcGC3yUUJmTGm+7XJRxuYi6IcD1Z5WuADAzn7Y985Kjvs/E6XUgAIwayIxKB2+Offti79FWAPi6me4kKsJv9ZPIesDaMfHOiNthsT29sBD1lVqtVeBZgAAKUfHd5PUW7+Ijm0vNrLblXP1HZ30l/Ovb/WkA0HzxCi2kHGQxM+QNSXF7z+iVYx8UHZzy7RtiVYTp/Fx55MGS6eUGS2ldwhCc7Z4uO5OQ2Q4ApwFAIwiIyRxy+796r7Phif3PXh6fvFeTb1gt335jU/XmPM273zN5D206ZMvwoXQ2l9J37PDEXRRd6xUoKAFOkTNH97icum3vn4/Kd37749fkc/UXSxxWQecwvGCoZPay6nAYIUjpIfiPt1zbOqzwOac2feQqobhgzPFoerNh4ee3rbuDS8s0Y3XQ8E7eUkwDEqBQ5AIiAhoxMkrk+/1hz/Hh308GcsLFVobR/MQQNCZAkOy5XMi7w/7PKoqQdUSF4uxfMdyNLy2Nrqzc6aII97GVlpjtyFOVhXXfAGAYwl4gYkOYBYBTyrm7UM7Hxh/VIqJk7TMrvNgTlPhpXZUlll9VkGJ4w3zKA5upGDqWL4+q3Gqb9IMPsi39z8IoQa/XbrTZvSO/PD/ZtLus+qBJXURI9KKCfYB8RgBjroCUiWNu1QMTZy6GQkTgRpoBAEJAUxndiZWJGoZQyoMC+XkF2GZ2YFbcgjExBWoKg4AipYiqypCrx5wn9dhSo2fW3tFZca+rtXZCmZq9FvTNzmEh7gfLahB9+D5KrbXQGhQsJ0OQsuLA6GTn4L6SwzzmJ5LrSwQAGOsdoEq0aVdnv7PowGFOI2BZDiCbySEqLUZS2rm+xz8+fVOnz7o7dnhkANhoWSIdPLSn+bG9W5tevT4zUKvXCHXJTJxIyur4lG/E/cnYLSUhc+1yUrgCQN7gwhpnmykfkKC6Bkgmy1+qYwh9UmGom5Mab/+Xzn8Dd8iKHl3kdcMAAAAASUVORK5CYII=', usr_comment: 'Lorem Ipsum dolor sit amet consectetur elit adipiscing. ur elit adipiscing', product: '#110899 Lorem Ipsum Dolor sit amet consectetur elit adi', badge_count: '5', date: '22/22/22', meta: [], isHighLight: true, }, { id: 1, name: 'Juana Rostran Marenco', mail: 'jnrostran@gmail.com', phone_number: '5231 5664', image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAOBSURBVDiNdZNrTFt1GMaf/zltz+kp7VgrtUw2WGF0QJRNqM4tcbDFuRAnkZhl8xIxJBKcEEzmF6OmSybxFi8Yl4Aki/hhM0STbWQlLoNFWTYZIFl0m6PrjUuB0kLbc9qe9vT8/aCQkOjv0/vpSZ68zw8A0D1dxuFfvmymzu52ygEAFX4szAmXTlCMaPA/kM9nivRswtirylx7+sPXdh2wV7cZzIJdiqf8tzzegTcGC3yUUJmTGm+7XJRxuYi6IcD1Z5WuADAzn7Y985Kjvs/E6XUgAIwayIxKB2+Offti79FWAPi6me4kKsJv9ZPIesDaMfHOiNthsT29sBD1lVqtVeBZgAAKUfHd5PUW7+Ijm0vNrLblXP1HZ30l/Ovb/WkA0HzxCi2kHGQxM+QNSXF7z+iVYx8UHZzy7RtiVYTp/Fx55MGS6eUGS2ldwhCc7Z4uO5OQ2Q4ApwFAIwiIyRxy+796r7Phif3PXh6fvFeTb1gt335jU/XmPM273zN5D206ZMvwoXQ2l9J37PDEXRRd6xUoKAFOkTNH97icum3vn4/Kd37749fkc/UXSxxWQecwvGCoZPay6nAYIUjpIfiPt1zbOqzwOac2feQqobhgzPFoerNh4ee3rbuDS8s0Y3XQ8E7eUkwDEqBQ5AIiAhoxMkrk+/1hz/Hh308GcsLFVobR/MQQNCZAkOy5XMi7w/7PKoqQdUSF4uxfMdyNLy2Nrqzc6aII97GVlpjtyFOVhXXfAGAYwl4gYkOYBYBTyrm7UM7Hxh/VIqJk7TMrvNgTlPhpXZUlll9VkGJ4w3zKA5upGDqWL4+q3Gqb9IMPsi39z8IoQa/XbrTZvSO/PD/ZtLus+qBJXURI9KKCfYB8RgBjroCUiWNu1QMTZy6GQkTgRpoBAEJAUxndiZWJGoZQyoMC+XkF2GZ2YFbcgjExBWoKg4AipYiqypCrx5wn9dhSo2fW3tFZca+rtXZCmZq9FvTNzmEh7gfLahB9+D5KrbXQGhQsJ0OQsuLA6GTn4L6SwzzmJ5LrSwQAGOsdoEq0aVdnv7PowGFOI2BZDiCbySEqLUZS2rm+xz8+fVOnz7o7dnhkANhoWSIdPLSn+bG9W5tevT4zUKvXCHXJTJxIyur4lG/E/cnYLSUhc+1yUrgCQN7gwhpnmykfkKC6Bkgmy1+qYwh9UmGom5Mab/+Xzn8Dd8iKHl3kdcMAAAAASUVORK5CYII=', usr_comment: 'Lorem Ipsum dolor sit amet consectetur elit adipiscing. ur elit adipiscing', product: '#110899 Lorem Ipsum Dolor sit amet consectetur elit adi', badge_count: '5', date: '22/22/22', meta: [], isHighLight: false, }, { id: 1, name: 'Juana Rostran Marenco', mail: 'jnrostran@gmail.com', phone_number: '5231 5664', image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAOBSURBVDiNdZNrTFt1GMaf/zltz+kp7VgrtUw2WGF0QJRNqM4tcbDFuRAnkZhl8xIxJBKcEEzmF6OmSybxFi8Yl4Aki/hhM0STbWQlLoNFWTYZIFl0m6PrjUuB0kLbc9qe9vT8/aCQkOjv0/vpSZ68zw8A0D1dxuFfvmymzu52ygEAFX4szAmXTlCMaPA/kM9nivRswtirylx7+sPXdh2wV7cZzIJdiqf8tzzegTcGC3yUUJmTGm+7XJRxuYi6IcD1Z5WuADAzn7Y985Kjvs/E6XUgAIwayIxKB2+Offti79FWAPi6me4kKsJv9ZPIesDaMfHOiNthsT29sBD1lVqtVeBZgAAKUfHd5PUW7+Ijm0vNrLblXP1HZ30l/Ovb/WkA0HzxCi2kHGQxM+QNSXF7z+iVYx8UHZzy7RtiVYTp/Fx55MGS6eUGS2ldwhCc7Z4uO5OQ2Q4ApwFAIwiIyRxy+796r7Phif3PXh6fvFeTb1gt335jU/XmPM273zN5D206ZMvwoXQ2l9J37PDEXRRd6xUoKAFOkTNH97icum3vn4/Kd37749fkc/UXSxxWQecwvGCoZPay6nAYIUjpIfiPt1zbOqzwOac2feQqobhgzPFoerNh4ee3rbuDS8s0Y3XQ8E7eUkwDEqBQ5AIiAhoxMkrk+/1hz/Hh308GcsLFVobR/MQQNCZAkOy5XMi7w/7PKoqQdUSF4uxfMdyNLy2Nrqzc6aII97GVlpjtyFOVhXXfAGAYwl4gYkOYBYBTyrm7UM7Hxh/VIqJk7TMrvNgTlPhpXZUlll9VkGJ4w3zKA5upGDqWL4+q3Gqb9IMPsi39z8IoQa/XbrTZvSO/PD/ZtLus+qBJXURI9KKCfYB8RgBjroCUiWNu1QMTZy6GQkTgRpoBAEJAUxndiZWJGoZQyoMC+XkF2GZ2YFbcgjExBWoKg4AipYiqypCrx5wn9dhSo2fW3tFZca+rtXZCmZq9FvTNzmEh7gfLahB9+D5KrbXQGhQsJ0OQsuLA6GTn4L6SwzzmJ5LrSwQAGOsdoEq0aVdnv7PowGFOI2BZDiCbySEqLUZS2rm+xz8+fVOnz7o7dnhkANhoWSIdPLSn+bG9W5tevT4zUKvXCHXJTJxIyur4lG/E/cnYLSUhc+1yUrgCQN7gwhpnmykfkKC6Bkgmy1+qYwh9UmGom5Mab/+Xzn8Dd8iKHl3kdcMAAAAASUVORK5CYII=', usr_comment: 'Lorem Ipsum dolor sit amet consectetur elit adipiscing. ur elit adipiscing', product: '#110899 Lorem Ipsum Dolor sit amet consectetur elit adi', badge_count: '5', date: '22/22/22', meta: [], isHighLight: false, }, { id: 1, name: 'Juana Rostran Marenco', mail: 'jnrostran@gmail.com', phone_number: '5231 5664', image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAOBSURBVDiNdZNrTFt1GMaf/zltz+kp7VgrtUw2WGF0QJRNqM4tcbDFuRAnkZhl8xIxJBKcEEzmF6OmSybxFi8Yl4Aki/hhM0STbWQlLoNFWTYZIFl0m6PrjUuB0kLbc9qe9vT8/aCQkOjv0/vpSZ68zw8A0D1dxuFfvmymzu52ygEAFX4szAmXTlCMaPA/kM9nivRswtirylx7+sPXdh2wV7cZzIJdiqf8tzzegTcGC3yUUJmTGm+7XJRxuYi6IcD1Z5WuADAzn7Y985Kjvs/E6XUgAIwayIxKB2+Offti79FWAPi6me4kKsJv9ZPIesDaMfHOiNthsT29sBD1lVqtVeBZgAAKUfHd5PUW7+Ijm0vNrLblXP1HZ30l/Ovb/WkA0HzxCi2kHGQxM+QNSXF7z+iVYx8UHZzy7RtiVYTp/Fx55MGS6eUGS2ldwhCc7Z4uO5OQ2Q4ApwFAIwiIyRxy+796r7Phif3PXh6fvFeTb1gt335jU/XmPM273zN5D206ZMvwoXQ2l9J37PDEXRRd6xUoKAFOkTNH97icum3vn4/Kd37749fkc/UXSxxWQecwvGCoZPay6nAYIUjpIfiPt1zbOqzwOac2feQqobhgzPFoerNh4ee3rbuDS8s0Y3XQ8E7eUkwDEqBQ5AIiAhoxMkrk+/1hz/Hh308GcsLFVobR/MQQNCZAkOy5XMi7w/7PKoqQdUSF4uxfMdyNLy2Nrqzc6aII97GVlpjtyFOVhXXfAGAYwl4gYkOYBYBTyrm7UM7Hxh/VIqJk7TMrvNgTlPhpXZUlll9VkGJ4w3zKA5upGDqWL4+q3Gqb9IMPsi39z8IoQa/XbrTZvSO/PD/ZtLus+qBJXURI9KKCfYB8RgBjroCUiWNu1QMTZy6GQkTgRpoBAEJAUxndiZWJGoZQyoMC+XkF2GZ2YFbcgjExBWoKg4AipYiqypCrx5wn9dhSo2fW3tFZca+rtXZCmZq9FvTNzmEh7gfLahB9+D5KrbXQGhQsJ0OQsuLA6GTn4L6SwzzmJ5LrSwQAGOsdoEq0aVdnv7PowGFOI2BZDiCbySEqLUZS2rm+xz8+fVOnz7o7dnhkANhoWSIdPLSn+bG9W5tevT4zUKvXCHXJTJxIyur4lG/E/cnYLSUhc+1yUrgCQN7gwhpnmykfkKC6Bkgmy1+qYwh9UmGom5Mab/+Xzn8Dd8iKHl3kdcMAAAAASUVORK5CYII=', usr_comment: 'Lorem Ipsum dolor sit amet consectetur elit adipiscing. ur elit adipiscing', product: '#110899 Lorem Ipsum Dolor sit amet consectetur elit adi', badge_count: '5', date: '22/22/22', meta: [], isHighLight: false, }]);
  const [selectOptions, setSelectOptions] = useState("1");

  const setShowLoading = useContext(LoadingContext)[1]

  const history = useHistory();

  const handleEditProductInventary = async (data) => {
    // const selectedAttributesState = await handleGetAttributeById(data.id);
    // if (!selectedAttributesState) return;

    data.meta._stock = data.meta._stock === null ? 0 : data.meta._stock;

    let temperatureOption = {};
    let enabledCheckTemp = false;
    if (data.meta.product_temperature_handler === "") {
      temperatureOption = { value: "select", label: "Select" };
    }
    if (data.meta.product_temperature_handler === "frio") {
      temperatureOption = { value: "frio", label: "Frío" };
    } else {
      temperatureOption = { value: "caliente", label: "Caliente" };
      enabledCheckTemp = true;
    }

    data.temperatureOption = temperatureOption;
    data.enabledCheckTemp = enabledCheckTemp;

    let categoryNew = data.category.filter(
      (catg) => catg.type === "product_cat"
    );

    let productVisibility = data.category.filter(
      (catg) => catg.type === "product_visibility"
    );

    //Producto destacado
    data.outstanding =
      data.category.filter(({ type, id }) => {
        return type === "product_visibility" && id === 8;
      }).length > 0
        ? true
        : false;

    //Formateando las categorias para la edicion en los selected
    data.category = categoryNew.map((catg) => {
      return {
        label: catg.name,
        value: catg.id,
      };
    });

    //Formateando las los prtoductos relacionado para la edicion en los selected
    data.relatedProducts = data.relatedProducts.map((related) => {
      return {
        ...related,
        label: related.name,
      };
    });

    //Verificamos si el producto esta protegido por contraseña
    data.visiblePassword = data.post_password.length > 0 ? true : false;

    /** Valor default select VISIBILIDAD*/
    let optionDefaultV = {};
    if (data.post_status === "private") {
      optionDefaultV = { value: "privada", label: "Privada" };
    } else if (data.post_password.length > 0) {
      optionDefaultV = {
        value: "protegido",
        label: "Protegido con contraseña",
      };
    } else {
      optionDefaultV = { value: "publica", label: "Pública" };
    }

    data.visibilityOption = optionDefaultV;
    /****************************************************/

    /**Valor default select VISIBLE EN */

    let optionDefaultV2 = {};
    if (productVisibility.length === 0) {
      optionDefaultV2 = {
        value: "tienda-y-busqueda",
        label: "En la tienda y en los resultados de búsqueda",
      };
    } else {
      if (productVisibility.length === 1) {
        if (productVisibility[0].id === 6) {
          optionDefaultV2 = { value: "tienda", label: "Solo en la tienda" };
        } else if (productVisibility[0].id === 7) {
          optionDefaultV2 = {
            value: "busqueda",
            label: "Solo en los resultados de búsqueda",
          };
        }
      } else {
        optionDefaultV2 = { value: "oculto", label: "Oculto" };
      }

      //KM
    }

    data.visibilityPlaceOption = optionDefaultV2;
    data.productVisibility = productVisibility.map((productV) => {
      return {
        name: productV.type,
        value: productV.id,
        action: "E",
      };
    });

    /********************************************** */

    // data.selectedAttributesState = selectedAttributesState;

    //Imagenes
    data.imagen._product_image_gallery = data.imagen._product_image_gallery.map((gallery) => {
      return {
        ...gallery,
        action: "E",
      };
    });
    console.log(data);

    history.push({
      pathname: "new-product",
      state: data,
    });
  };

  const headerOpt = [
    {
      id: "1",
      name: `Todos (${data.length})`,
      data,
    },
    {
      id: "2",
      name: `Míos`,
      data: dataPublish,
    },
    {
      id: "3",
      name: `Pendientes`,
      data: dataDraft,
    },
    {
      id: "4",
      name: `Aprobados`,
      data: dataAproved,
    },
    {
      id: "5",
      name: `Papelera`,
      data: dataTrash,
    },
  ];

  const handleConvertMeta = (data) => {
    return data.map((data, idx) => {
      Object.keys(data.meta).forEach((key) => {
        return (data.meta[key] = data.meta[key][0]);
      });

      return {
        ...data,
      };
    });
  };

  const handleListProduct = useCallback(
    async (id = "12739") => {
      setShowLoading(true);

      try {
        const response = await axios.post(
          "https://kakaomarket.cr/wp-json/sellerconsole/v1/get_inventary_data",
          {
            idSeller: id,
          }
        );
        if (response.status === 200) {
          let dataParse = JSON.parse(response.data);

          setDataPublish(handleConvertMeta(dataParse.publish));
          setDataDraft(handleConvertMeta(dataParse.draft));
          setDataAproved(handleConvertMeta(dataParse.aproved));
          setDataTrash(handleConvertMeta(dataParse.trash));
          setData(handleConvertMeta(dataParse.result));
          setShowLoading(false);
        }
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: "Ha ocurrido un error al obtener información de los comentarios",
          icon: "error",
        });
        setShowLoading(false);
      }
    },
    [setShowLoading]
  );

  const handleDeleteProductInventary = useCallback(
    (id) => {
      Swal.fire({
        title: `¿Seguro que quiere eliminar el comentario de la lista?`,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          try {
            setShowLoading(true);
            const response = await axios.post(
              "https://kakaomarket.cr/wp-json/sellerconsole/v1/delete_producto_inventary",
              {
                idProduct: id,
              }
            );

            if (response.status === 200) {

              let product = data.find((product) => product.id === id)
              product.post_status = "trash"
              setDataPublish(dataPublish.filter((product) => product.id !== id)
              );
              setDataDraft(dataDraft.filter((product) => product.id !== id));
              setDataAproved(dataDraft.filter((product) => product.id !== id));
              setDataTrash(dataTrash.concat(product));
              Swal.fire("¡Comentario eliminado!", "", "success");
              setShowLoading(false);
            }
          } catch (error) {
            Swal.fire({
              title: "Error",
              text: "Ha ocurrido un error al eliminar el comentario de la lista",
              icon: "error",
            });
            setShowLoading(false);
          }
        }
      });
    },
    [data, dataPublish, dataDraft, dataTrash, setShowLoading]
  );

  useEffect(() => {
    handleListProduct(user.vendorId);
  }, [handleListProduct, user.vendorId]);

  const handleOptionsSelected = (id) => {
    setShowLoading(true);
    setTimeout(() => {
      setSelectOptions(id);
      setShowLoading(false);
    }, 3000);
  };

  return (
    <HeadContainer
      title={'Comentarios'}>
      <HeaderOptions
        headerOpt={headerOpt}
        handleOptionsSelected={handleOptionsSelected}
      //setShowLoading={setShowLoading}
      />
      {headerOpt.map(({ data, id }, idx) => (
        <Table
          id={idx}
          key={idx}
          data={data}
          props={props}
          isVisible={selectOptions === id ? true : false}
          setShowLoading={setShowLoading}
          handleEditProductInventary={handleEditProductInventary}
          handleDeleteProductInventary={handleDeleteProductInventary}
        />
      ))}
    </HeadContainer>
  );
};

const Table = ({
  id,
  data,
  props,
  isVisible,
  setShowLoading,
  handleEditProductInventary,
  handleDeleteProductInventary,
}) => {
  const [activeEnter, setActiveEnter] = useState("");
  const [optionsInventary, setOptionsInventary] = useState("");
  const [isEnableBtn, setIsEnableBtn] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const prevIcon = (
    <svg
      style={{ cursor: "pointer" }}
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 13.3727C8.83333 12.9848 8.83333 12.0152 9.5 11.6273L15.5 8.13651C16.1667 7.74865 17 8.23348 17 9.00921V15.9908C17 16.7665 16.1667 17.2514 15.5 16.8635L9.5 13.3727Z"
        fill="#37474F"
      />
      <path
        d="M2 1H24V-1H2V1ZM25 2V23H27V2H25ZM24 24H2V26H24V24ZM1 23V2H-1V23H1ZM2 24C1.44772 24 1 23.5523 1 23H-1C-1 24.6569 0.343146 26 2 26V24ZM25 23C25 23.5523 24.5523 24 24 24V26C25.6569 26 27 24.6569 27 23H25ZM24 1C24.5523 1 25 1.44772 25 2H27C27 0.343146 25.6569 -1 24 -1V1ZM2 -1C0.343146 -1 -1 0.343145 -1 2H1C1 1.44772 1.44772 1 2 1V-1Z"
        fill="#C8CBCC"
      />
    </svg>
  );

  const nextIcon = (
    <svg
      style={{ cursor: "pointer" }}
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 11.6273C16.1667 12.0152 16.1667 12.9848 15.5 13.3727L9.5 16.8635C8.83333 17.2514 8 16.7665 8 15.9908L8 9.00921C8 8.23348 8.83333 7.74864 9.5 8.13651L15.5 11.6273Z"
        fill="#37474F"
      />
      <path
        d="M2 1H24V-1H2V1ZM25 2V23H27V2H25ZM24 24H2V26H24V24ZM1 23V2H-1V23H1ZM2 24C1.44772 24 1 23.5523 1 23H-1C-1 24.6569 0.343146 26 2 26V24ZM25 23C25 23.5523 24.5523 24 24 24V26C25.6569 26 27 24.6569 27 23H25ZM24 1C24.5523 1 25 1.44772 25 2H27C27 0.343146 25.6569 -1 24 -1V1ZM2 -1C0.343146 -1 -1 0.343145 -1 2H1C1 1.44772 1.44772 1 2 1V-1Z"
        fill="#C8CBCC"
      />
    </svg>
  );

  const perPage = 8
  const [page, setPage] = useState([]);

  useEffect(() => {
    setPage(data.slice(0, perPage));
  }, [data]);

  const handlePageClick = (evt) => {
    const selectedPage = evt.selected;
    const offset = selectedPage * perPage;

    //setFilteredOrders(orders.slice(offset, offset + perPage))
    setPage(filteredData.slice(offset, offset + perPage));
  };

  const filteredData = useMemo(() => {
    let dataGlobal = data;

    //Si esta vacio el search se retorna la dara original
    if (!activeEnter && optionsInventary.length === 0) {
      setPage(dataGlobal.slice(0, perPage));
      return dataGlobal;
    }

    //Se filtra por Existencia o Bajo por inventario
    if (optionsInventary.length > 0) {
      dataGlobal = dataGlobal.filter(({ meta }) => {
        const { _stock_status } = meta;
        return _stock_status === optionsInventary ? true : false;
      });
    }

    dataGlobal = dataGlobal.filter(({ post_title }) =>
      post_title.toLowerCase().includes(activeEnter)
    );
    setPage(dataGlobal.slice(0, perPage));

    //Se filtra por lo que tenga el search
    return dataGlobal;
  }, [activeEnter, data, optionsInventary]);

  const handleRowSelect = (key, isForPushTheEvent) => {
    let updatedItems;

    if (isForPushTheEvent) {
      updatedItems = selectedItems.map((item) => item);
      updatedItems.push(key);
    } else {
      updatedItems = selectedItems.filter((item) => item !== key);
    }

    setSelectedItems(updatedItems);
    setIsEnableBtn(updatedItems.length > 0);
  }

  return (
    <div style={{ display: `${isVisible ? "block" : "none"}` }}>
      <div className="commentFilter">
        <div className="commentLeft">
          <Search setActiveEnter={setActiveEnter} id={id} />
          <div className="select">
            <h2>Fecha</h2>
            <input
              className="custom-input"
              type="date"
              placeholder={'Elegir fecha'}
              style={{ marginLeft: 10 }} />
          </div>
        </div>
        <Button
          classname={isEnableBtn ? "primary" : "primaryDisabled"}
          onClick={() => { }}>
          Aprobar
        </Button>
        <Button
          classname={isEnableBtn ? "secondary" : "secondaryDisabled"}
          onClick={() => { }}>
          <RiDeleteBin5Line
            style={{
              width: "20px",
              height: "20px",
              marginRight: "4px",
            }} />
          Eliminar
        </Button>
      </div>
      <div className="inventoryTable">
        <table className="salesTable" style={{ width: "100%" }}>
          <thead style={{ textAlign: "left" }}>
            <tr>
              <th className="tableHeaderItem" colSpan="1" />
              <th className="tableHeaderItem" colSpan="6">Usuario</th>
              <th className="tableHeaderItem" colSpan="6">
                Comentario
              </th>
              <th className="tableHeaderItem" colSpan="6">
                Producto
              </th>
              <th className="tableHeaderItem" colSpan="6">
                Fecha <FaCaretDown />
              </th>
            </tr>
          </thead>
          <tbody style={{ height: page.length === 0 ? "10px" : null }}>
            {page.length > 0 && (
              <>
                {page.map((comment, idx) => {
                  const {
                    id,
                    name,
                    mail,
                    phone_number,
                    image,
                    usr_comment,
                    product,
                    badge_count,
                    meta,
                    date,
                    isHighLight,
                  } = comment;

                  return (
                    <TableRow
                      id={id}
                      idx={idx}
                      name={name}
                      mail={mail}
                      phone_number={phone_number}
                      image={image}
                      usr_comment={usr_comment}
                      product={product}
                      badge_count={badge_count}
                      date={date}
                      meta={meta}
                      isHighLight={isHighLight}
                      handleRowSelect={handleRowSelect} />
                  );
                })}
              </>
            )}
          </tbody>
        </table>
        {page.length === 0 && (
          <div className="inventoryNotFound">
            <div className="inventoryNotFoundContainer">
              <p className="inventoryNotFoundTittle">No hay comentarios</p>
            </div>
          </div>
        )}
        <div>
          {page.length > 0 && (
            <div>
              <ReactPaginate
                onPageChange={handlePageClick}
                previousLabel={prevIcon}
                nextLabel={nextIcon}
                breakLabel={"..."}
                pageCount={Math.ceil(filteredData.length / perPage)}
                pageRangeDisplayed={5}
                marginPagesDisplayed={2}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          )}
        </div>
      </div>

    </div>
  );
}

const Button = ({ children, classname, onClick }) => {
  return (
    <button className={`commentBtn ${classname} `} onClick={onClick}>
      {children}
    </button>
  )
}

const TableRow = ({
  id,
  idx,
  handleRowSelect,
  name,
  mail,
  phone_number,
  image,
  usr_comment,
  product,
  badge_count,
  meta,
  date,
  isHighLight
}) => {

  const [isShowBtn, setIsShowBtn] = useState(false);
  const [isSelected, setIsSelected] = useState(false);

  const handleAnimation = (e) => {
    if (e.target.checked)
      setIsSelected(true)
    else
      setIsSelected(false)
  }

  return (
    <tr key={`${id}${idx}`} className={isSelected ?
      'flexContainewRowChecked' :
      isHighLight ? 'flexContainerHighLightRow' : 'flexContainerRow'
    }
      onMouseEnter={(e) => {
        setIsShowBtn(true);
      }}
      onMouseLeave={(e) => {
        setIsShowBtn(false);
      }}>
      <td className="checkboxFlex">
        <input className={'inputComment'} type="checkbox" onChange={(e) => {
          handleAnimation(e);
          handleRowSelect(`${id}${idx}`, e.target.checked)
        }} />
      </td>
      <td className="imageTdFlex">
        <div className="imageContainerTdFlex">
          <div className="commentImageCircle">
            <img src={image} alt='usr profile' />
          </div>
        </div>
        <div className="contentContainerTdFlex">
          <h6 className="titleText">{name}</h6>
          <p className="contentText">{mail}</p>
          <p className="contentText">{phone_number}</p>
        </div>
      </td>
      <td className="commentTdFlex">
        <p className="contentCommentText">{usr_comment}</p>
      </td>
      <td className="productTdFlex">
        <p className="contentProductText">{product}</p>
        <p className="commentCounter"><FaRegComment /> {badge_count}</p>
      </td>
      <td className="dateTdFlex">
        <p className="dateText">{date}</p>
      </td>
      <td className={isShowBtn ? 'buttonTdFlexShow' : 'buttonTdFlexNotShow'}>
        {isShowBtn && (
          <>
            <Button
              classname="primary topMarginClass"
              onClick={() => {
                //handleEditProductInventary(product);
              }}
            >
              Aprobar
            </Button>
            <Button
              classname="secondary topMarginClass"
              onClick={() => {
                //handleDeleteProductInventary(id);
              }}
            >
              <RiDeleteBin5Line
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "4px",
                }}
              />
              Eliminar
            </Button>
          </>
        )}
      </td>
    </tr>
  )
}


export default Comments
